import { Layout, Card } from 'antd';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Card style={{ width: 420, boxShadow: '0 2px 8px rgba(0,0,0,0.09)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h1 style={{ fontSize: 24, fontWeight: 600, margin: 0 }}>Invex Admin</h1>
          <p style={{ color: '#8c8c8c', margin: '8px 0 0' }}>Administration Panel</p>
        </div>
        <Outlet />
      </Card>
    </Layout>
  );
}
